export default ({ axios, mapQueryString }) => ({
    index: (branch_id, filters = {}) => axios.get(`/branches/${branch_id}/branch-properties${mapQueryString(filters)}`),
    // show: (branch_id, property_id, filters = {}) => axios.get(`/branches/${branch_id}/properties/${property_id}${mapQueryString(filters)}`),
    /**
     *
     * @param branch_id
     * @param property_id
     * @param body
     * @description expected body: {
     *       base_price_e2: "integer",
     *       step_price_e2: "integer",
     *       quantity: "integer",
     *       available: "boolean"
     *   }
     */
    update: (branch_id, property_id, body) => axios.patch(`/branches/${branch_id}/properties/${property_id}`, body),
    branchPropertyUpdate: (branch_property_id, body) => axios.patch(`/branch-properties/${branch_property_id}`, body)

})



// WEBPACK FOOTER //
// ./src/api/branchProperties.js